module.exports = __webpack_public_path__ + "static/media/臺大語言所碩士班入學考試選考科目建議閱讀書單20200721.3abbfd82.docx";